import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s("Historial de Sandboxes")),
      ]),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onEnableFilter },
                  },
                  [
                    _vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-off-outline"),
                        ])
                      : _vm._e(),
                    !_vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-outline"),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            !_vm.items.length
              ? _c("state-component", {
                  attrs: {
                    state: "empty_state",
                    title: "No se tienen Sandbox creados.",
                    subtitle: "Una vez que se tengan, podrás verlos aquí",
                  },
                })
              : _c(
                  VCard,
                  [
                    _c(VDataTable, {
                      staticClass: "text-center table-inca",
                      attrs: {
                        responsive: "",
                        hover: "",
                        items: _vm.items,
                        headers: _vm.headers,
                        search: _vm.search,
                        "hide-default-footer": "",
                        "items-per-page": _vm.pagination.limit,
                        page: _vm.pagination.current,
                      },
                      on: {
                        pagination: function ($event) {
                          _vm.pagination.total = $event.itemsLength
                        },
                        "update:page": function ($event) {
                          return _vm.$set(_vm.pagination, "current", $event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.creation_date",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(new Date(item.creation_date))
                                      .format("DD/MM/YYYY")
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.status_id",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              item.flag_attribute_alert === "1"
                                ? _c(
                                    VTooltip,
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VChip,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          "text-color":
                                                            _vm.getUseCaseStatus(
                                                              item.status_id
                                                            ).textColor,
                                                          color:
                                                            _vm.getUseCaseStatus(
                                                              item.status_id
                                                            ).color,
                                                        },
                                                      },
                                                      "v-chip",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.getUseCaseStatus(
                                                            item.status_id
                                                          ).status
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      VIcon,
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "2px",
                                                        },
                                                        attrs: { small: "" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-alert-circle-outline"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.response)),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    VChip,
                                    {
                                      attrs: {
                                        small: "",
                                        "text-color": _vm.getUseCaseStatus(
                                          item.status_id
                                        ).textColor,
                                        color: _vm.getUseCaseStatus(
                                          item.status_id
                                        ).color,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getUseCaseStatus(item.status_id)
                                              .status
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center",
                                },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onOpenDialogUseCase(
                                                              item,
                                                              _vm.DIALOG_SEE_REPORT_DETAIL
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-view")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Ver detalle")])]
                                  ),
                                  item.status_id === 2
                                    ? _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VBtn,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "btn-icon-inca",
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onOpenDialogUseCase(
                                                                  item,
                                                                  _vm.DIALOG_CHANGE_STATUS
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-progress-alert"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("cambiar a observado"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  item.status_id !== 20
                                    ? _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VBtn,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "btn-icon-inca",
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openDeleteDialog(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [_vm._v("mdi-delete")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [_c("span", [_vm._v("Eliminar")])]
                                      )
                                    : _vm._e(),
                                  item.status_id !== 20
                                    ? _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      VBtn,
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "btn-icon-inca",
                                                            attrs: {
                                                              icon: "",
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openSwitchOwnerDialog(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          VIcon,
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-account-arrow-right"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("Cambiar de propietario"),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("pagination-vue", {
                      attrs: { pagination: _vm.pagination },
                    }),
                  ],
                  1
                ),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                      ),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VSelect, {
                                  attrs: {
                                    label: _vm.translate(
                                      "table_ownership_history.organization"
                                    ),
                                    placeholder: _vm.translate(
                                      "table_ownership_history.organization"
                                    ),
                                    outlined: "",
                                    dense: "",
                                    items: _vm.getOrganizations,
                                  },
                                  model: {
                                    value: _vm.choose_organization,
                                    callback: function ($$v) {
                                      _vm.choose_organization = $$v
                                    },
                                    expression: "choose_organization",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t(
                                      "attributes.label.use_case_name"
                                    ),
                                    placeholder: _vm.$t(
                                      "attributes.placeholder.use_case"
                                    ),
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.use_case_name,
                                    callback: function ($$v) {
                                      _vm.use_case_name = $$v
                                    },
                                    expression: "use_case_name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c("calendar-component", {
                                  attrs: { placeholder: "Fecha de creación" },
                                  model: {
                                    value: _vm.creation_date,
                                    callback: function ($$v) {
                                      _vm.creation_date = $$v
                                    },
                                    expression: "creation_date",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12 mt-3" } },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { dense: "", outlined: "" },
                                    on: { click: _vm.onResetFilters },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12 mt-3" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("attributes.label.total_records")
                                    ) +
                                    ": " +
                                    _vm._s(_vm.totalRecords) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_SEE_REPORT_DETAIL,
        attrs: {
          title: _vm.$t("titles.use_case_report"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("use-case-detail-component", {
                  attrs: { item: _vm.useCase },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CHANGE_STATUS,
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de cambiar el estado a Observado?",
        },
        on: { onConfirm: _vm.onOkObserved },
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_CHANGE_STATUS,
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de cambiar el estado a Observado?",
        },
        on: { onConfirm: _vm.onOkObserved },
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE,
        attrs: {
          title: "Confirmación de Eliminación",
          text: "¿Estás seguro de eliminar este registro?",
          width: 450,
        },
        on: { onConfirm: _vm.handleDeleteConfirm },
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_SWITCH_OWNER,
        attrs: { title: "Cambiar propietario", width: 500 },
        on: { close: _vm.resetSwitchOwnerDialog },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VForm,
                  {
                    ref: "switchOwnerForm",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.formOK,
                      callback: function ($$v) {
                        _vm.formOK = $$v
                      },
                      expression: "formOK",
                    },
                  },
                  [
                    _c(VTextField, {
                      attrs: {
                        label: "Nuevo propietario",
                        rules: _vm.rules.new_owner,
                        outlined: "",
                        dense: "",
                        loading: _vm.isSwitchingOwner,
                      },
                      model: {
                        value: _vm.newOwner,
                        callback: function ($$v) {
                          _vm.newOwner = $$v
                        },
                        expression: "newOwner",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: {
                      color: "primary",
                      disabled: !_vm.formOK,
                      loading: _vm.isSwitchingOwner,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSwitchOwnerConfirm()
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }